var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{class:_vm.notop ? 'mx-auto pa-4' : 'mx-auto mt-8 pa-4',staticStyle:{"width":"95%","max-width":"1000px","box-sizing":"border-box"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }